import { formatEnrolledTotal } from "../helper"

const EnrolledDebtSummary = ({ selectedCreditLines }) => {
  const count = selectedCreditLines?.length || 0

  return (
    <div className="text-text-secondary font-semibold">
      Total Enrolled Debt: {formatEnrolledTotal(selectedCreditLines)} · {count} {count === 1 ? "debt" : "debts"}
    </div>
  )
}

export default EnrolledDebtSummary
